module.exports = __webpack_public_path__ + "static/media/teygja_abs_small.dd536bdb.png";